import { ReactNode, useState } from "react";
import ChatMessages from "../../components/chatMessages";
import Calendar from "../../components/calendar";
import { Sidebar } from "@rio-cloud/rio-uikit";
import AssetTreeSidebar from "../../components/assetsTree";
import { useLocation } from "react-router-dom";

export type SidebarDemoKey = "showSidebarLeft";

export type SidebarProps = Partial<Record<SidebarDemoKey, boolean>> & {
  assetIds: string[];
  groupIds: string[];
  setAssetIds: (assetIds: string[]) => void;
  setGroupIds: (groupIds: string[]) => void;
  setChassisList: (chassisList: string[]) => void;
  children: ReactNode;
  onSidebarStateChange?: (isOpen: boolean) => void;
};

const LeftSidebar = (props: SidebarProps) => {
  const [showAssetTree, setShowAssetTree] = useState(false);

  const showAssetTreeFromRoutes = [
    "/fleet-manager/preventive-maintenance",
    "/fleet-manager/maintenance-monitoring",
    // "/fleet-manager/support"
  ];
  const location = useLocation();
  const currentRoute = location.pathname;
  const enableAssetTree = showAssetTreeFromRoutes.some((route) =>
    currentRoute.includes(route)
  );

  return (
    <div
      className="flex overflow-hidden"
      style={{ height: "calc(100vh - 50px)" }}
    >
      <div className="icons-col" style={{ minWidth: "50px" }}>
        {enableAssetTree ? (
          <span
            className="rioglyph rioglyph-truck"
            onClick={() => {
                const newState = !showAssetTree;
                setShowAssetTree(newState);
                props.onSidebarStateChange?.(newState);

            }}
          />
        ) : (
          <span />
        )}

        <div className="display-flex flex-column align-items-center icons-col__bottom">
          {/* <Indicators
            persona={"MANAGER"}
            setChassisList={props.setChassisList}
          /> */}
          <ChatMessages />
          <Calendar />

          {enableAssetTree ? (
            <span
              className={`rioglyph rioglyph-chevron-${
                showAssetTree ? "left" : "right"
              }`}
              onClick={() => {
                const newState = !showAssetTree;
                setShowAssetTree(newState);
                props.onSidebarStateChange?.(newState);
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>

      {/* Asset Tree */}
      {enableAssetTree && (
        <Sidebar closed={!showAssetTree} minWidth={300} resizable disableClose>
          <div className="w-full">
            <AssetTreeSidebar
              assetIds={props.assetIds}
              setAssetIds={props.setAssetIds}
              groupIds={props.groupIds}
              setGroupIds={props.setGroupIds}
              selectionLimit={
                currentRoute.includes("/fleet-manager/maintenance-monitoring")
                  ? 10000
                  : undefined
              }
            />
          </div>
        </Sidebar>
      )}

      <div className="w-full">{props.children}</div>
    </div>
  );
};

export default LeftSidebar;
